/* eslint-disable no-console */
import React, { useEffect, FC } from 'react'
import { useAuth, useAnalytics } from 'reactfire'
import { useHistory } from 'react-router-dom'

import { sendInitialQuizAnswers } from './utils'

import { useDispatch } from 'src/store'
import { QUIZZES, SIGN_UP } from 'src/constants/routes'
import { LoadingScreen } from 'src/components/Loading'
import { getUser } from 'src/api/user/user'
import { updateTokens } from 'src/utils/client'
import { EmailForSignInKey } from 'src/constants/localStorageKeys'
import { analyticsEvents } from 'src/constants/analytics/events'

const Login: FC = () => {
  const dispatch = useDispatch()
  const auth = useAuth()
  const { logEvent } = useAnalytics()
  const { push } = useHistory()

  useEffect(() => {
    const login = async () => {
      const email = window.localStorage.getItem(EmailForSignInKey)
      if (email) {
        try {
          const loginUser = await auth.signInWithEmailLink(
            email,
            window.location.href
          )

          const tokenResponse = await loginUser?.user?.getIdTokenResult()

          // set tokens in local storage
          if (tokenResponse?.token) {
            const refreshToken = loginUser?.user?.refreshToken
            if (refreshToken) {
              updateTokens({
                accessToken: tokenResponse.token,
                expiration: tokenResponse.expirationTime,
                refreshToken,
              })
            }

            window.localStorage.removeItem(EmailForSignInKey)

            const userData = await getUser()

            dispatch.user.setUser(userData)
            if (userData.profileComplete) {
              await sendInitialQuizAnswers()
            }

            logEvent(analyticsEvents.onboardingEmailConfirmed)
            push(userData.profileComplete ? QUIZZES : SIGN_UP)
          } else {
            console.log('wrong token')
          }
        } catch (error) {
          console.error(error)
        }
      } else {
        console.error('wrong email')
      }
    }

    login()
  }, [auth, dispatch, logEvent, push])

  return <LoadingScreen />
}

export default Login
